import * as React from 'react';

import { reportError } from 'app/utils/error-reporting';

export default class ErrorBoundary extends React.Component {
  // retry: () => void;

  static getDerivedStateFromError(error) {
    if (__DEV__) {
      console.log('ErrorBoundary.getDerivedStateFromError');
      console.error(error);
    }
    reportError(error);

    return { hasError: true }; // Update state so the next render will show the fallback UI.
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false, retried: false };

    // this.retry = this.retry.bind(this);
  }

  componentDidCatch(error, info) {
    if (__DEV__) {
      console.log('ErrorBoundary.componentDidCatch');
      console.error(error);
      console.warn(info);
    }
    reportError(error, info);
  }

  retry() {
    if (this.state.retried === false) {
      return this.setState({ hasError: false, retried: true });
    }
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ fontSize: '2em', textAlign: 'center', margin: '1em 0' }}>
          Øv! Noget gik galt. <button onClick={this.retry}>Prøv igen</button>
        </div>
      );
    }
    const { component, ...props } = this.props;
    if (component) {
      const Component = component;
      return <Component {...props} />;
    }

    return this.props.children;
  }
}
